import React from 'react';
import { motion } from 'framer-motion';
import Scene3D from './Scene3D';

const Hero = ({ title, subtitle, heroAsset, theme, productId }) => {
    return (
        <div className="relative h-screen w-full overflow-hidden bg-black">
            {heroAsset.type === 'video' ? (
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="absolute top-0 left-0 w-full h-full object-contain z-0"
                >
                    <source src={heroAsset.src} type="video/mp4" />
                </video>
            ) : heroAsset.type === '3d' ? (
                <div className="absolute top-0 left-0 w-full h-full z-0 bg-gradient-to-b from-gray-100 to-gray-200">
                    <Scene3D
                        frontImage={heroAsset.frontImage}
                        backImage={heroAsset.backImage}
                        color={heroAsset.color}
                    />
                </div>
            ) : (
                <div className="absolute top-0 left-0 w-full h-full z-0">
                    <img
                        src={heroAsset.src}
                        alt="Hero Background"
                        className="w-full h-full object-cover"
                    />
                </div>
            )}

            <div className={`absolute inset-0 ${theme?.bg || 'bg-black/20'} z-10`} />

            <div className="relative z-20 h-full flex flex-col justify-center items-center text-center px-4">
                <motion.h1
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    className={`${theme?.text || 'text-off-white'} font-sans font-bold text-6xl md:text-8xl lg:text-9xl tracking-tighter`}
                >
                    {title}
                </motion.h1>
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 1 }}
                    className={`mt-4 ${theme?.text || 'text-off-white'} text-xl md:text-2xl font-light tracking-widest uppercase`}
                >
                    {subtitle}
                </motion.p>
            </div>
        </div>
    );
};

export default Hero;
